import { Link } from "@mui/material"
import { NavLink } from "react-router-dom"

const Anchor = ({children, ...props}) => {
  return (
    <Link
        component={NavLink}
        variant="body2"
        underline="none"
        sx={{
          display: "block"
        }}
        {...props}
        >
        {children}
    </Link>
  )
}

export default Anchor